if (!customElements.get('jumplink-nav')) {
  class JumplinkNav extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.custom-jumplink-nav__track');
      if (!this.track) return;

      this.build();

      if (window.Shopify && Shopify.designMode) {
        ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((name) =>
          document.addEventListener(name, () => this.build())
        );
      }
    }

    build() {
      this.track.querySelectorAll('.custom-jumplink-nav__link').forEach((link) => link.remove());

      const targets = Array.from(document.querySelectorAll('[id][data-jumplink-title]')).slice(0, 5);
      targets.forEach((target) => {
        const link = document.createElement('a');
        link.className = 'custom-jumplink-nav__link';
        link.href = `#${target.id}`;
        link.textContent = target.dataset.jumplinkTitle;
        this.track.append(link);
      });

      this.hidden = targets.length === 0;
    }
  }

  customElements.define('jumplink-nav', JumplinkNav);
}
